export class Address {
  /**
   * Address first
   */
  addressLine1: string;

  /**
   * Address second
   */
  addressLine2: string;

  /**
   * Address city
   */
  city: string;

  /**
   * Address state
   */
  state: string;

  /**
   * Address country
   */
  country: string;

  /**
   * Address postal code
   */
  zipCode: string;

  /**
   *
   */
  entries?: number;

  /**
   *
   */
  secondary: string;

  constructor(obj: Partial<Address>) {
    Object.assign(this, obj);
  }

  get isValid() {
    if (this.addressLine1 && this.city && this.state && this.zipCode) {
      return true;
    }

    return false;
  }

  get isEmpty() {
    return !this.addressLine1 && !this.city && !this.state && !this.zipCode;
  }

  get fullAddress() {
    const addressComponents = [
      [this.addressLine1, this.secondary, this.city].filter(Boolean).join(' '),
      [this.state, this.zipCode].filter(Boolean).join(' '),
      [this.country].filter(Boolean).join(' '),
    ];

    const addressString = addressComponents.filter(Boolean).join(', ');

    if (addressString) {
      return addressString;
    } else {
      return '';
    }
  }

  toString() {
    return this.addressLine1 || '';
  }

  compareTo(address: Address) {
    if (address) {
      return (
        this.addressLine1 === address.addressLine1 &&
        this.secondary === address.secondary &&
        this.city === address.city &&
        this.state === address.state &&
        this.zipCode === address.zipCode &&
        this.country === address.country
      );
    }
    return false;
  }

  copyWith(address: Partial<Address>): Address {
    return new Address(
      Object.assign({}, this, {
        ...address,
      }),
    );
  }

  static empty(): Address {
    return new Address({
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
      entries: 0,
      secondary: '',
    });
  }
}
export interface VerificationAddressResponse {
  result: Address[];
  prefix: string;
  maxSuggestions: number;
}

export interface AddressSuggestion {
  streetLine: string;
  secondary: string;
  city: string;
  state: string;
  zipcode: string;
  entries: number;
}

export interface AddressSuggestion2 {
  city: string;
  entries?: number;
  secondary?: string;
  source: 'postal' | 'geolocate';
  state: string;
  streetLine: string;
  zipcode: string;
}
